import styled from '@emotion/styled';
import { SectionBox } from 'src/components-dummy';

export const SectionBoxStyled = styled(SectionBox)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 40px 32px;
`;
